import Tracker from 'tracks/tracker';

import constants from '@/constants/const';
import { NewTracking } from '@/constants/track';
import { getCookie } from '@/utils/cookie';

export const formatParam = param => {
  const { mod_nm, mod_pos, sec_nm, sec_pos, ...rest } = param || {};
  return {
    mod_nm: mod_nm ?? null,
    mod_pos: mod_pos ?? null,
    sec_nm: sec_nm ?? null,
    sec_pos: sec_pos ?? null,
    ...rest
  };
};
const formatBanner = param => {
  if (!param) return null;
  const { banner_id, banner_key, banner_pos, banner_type, url } = param;
  return {
    banner_id: !!banner_id ? `${banner_id}` : null,
    banner_key: !!banner_key ? `${banner_key}` : null,
    banner_pos: param?.banner_pos,
    banner_type: !!banner_type ? `${banner_type}` : null,
    url: !!url ? `${url}` : null,
    message_type: param?.message_type
  };
};
const formatEllipse = param => {
  if (!param) return null;
  return {
    ellipse_label: param?.ellipse_label,
    ellipse_pos: param?.ellipse_pos,
    ellipse_type: param?.ellipse_type,
    is_new: param?.is_new
  };
};
const formatFilterBtn = param => {
  if (!param) return null;
  return {
    button_nm: param?.button_nm,
    button_pos: param?.button_pos,
    is_selected: param?.is_selected,
    is_available: param?.is_available,
    is_soldout: param?.is_soldout
  };
};
export const formatCtx = param => {
  if (!param) return null;
  return {
    ...param,
    filter_sub_category: param?.filter_sub_category || void 0,
    catalogue_num: param?.catalogue_num || void 0,
    sort: param?.sort || void 0,
    filters: param?.filters || void 0,
    page_target: param?.page_target,
    page_tab: param?.page_tab,
    filter_store: param?.filter_store,
    brand_name: param?.brand_name,
    language_name: param?.language_name,
    review_target: param?.review_target,
    group_filter: param?.group_filter
  };
};
const formatProductInfo = (data, isFromCart) => {
  if (!data) return null;
  // 增加extra_attrs处理逻辑
  let parsedExtraAttrs = null;
  if (data?.extra_attrs) {
    try {
      parsedExtraAttrs = JSON.parse(data.extra_attrs);
    } catch (error) {
      console.error('Failed to parse extra_attrs:', error);
    }
  }

  // 没有展示在页面上的数据，不传，that's why we need those showXXX
  return {
    prod_pos: data?.index,
    prod_id: data?.id || data?.product_id,
    prod_name: isFromCart ? data?.title : data?.name,
    price: data?.price,
    base_price: data?.base_price ?? void 0,
    with_photo: data?.with_photo,
    product_vendor_id: data?.product_vendor_id,
    discount_percentage: data?.discount_percentage,
    sold_status: isFromCart ? data?.reason_type : data?.sold_status,
    last_week_sold_count_ui: data?.showWeekly ? data?.last_week_sold_count_ui || void 0 : void 0,
    is_pantry: data?.is_pantry,
    is_limit_product: data?.is_limit_product,
    is_sponsored: data?.is_sponsored ?? false,
    is_manual: data?.is_manual,
    is_mkpl: data?.biz_type === 'seller',
    is_fbw: data?.biz_type === 'fbw' ? true : false,
    restock_tip: data?.restock_tip,
    policy_pop_config_key: data?.policy_pop_config_key,
    progress: data?.progress,
    qty_in_cart: data?.qty_in_cart,
    // activity_tag_list: data?.showActivity && data?.activity_tag_list?.length > 0 ? data?.activity_tag_list : void 0,
    activity_tag_list: data?.product_tag_list?.length > 0 ? [data?.product_tag_list[0]?.tag_name] : void 0,
    label_list:
      data?.showLabel && data?.label_list?.map(vv => vv?.label_name)?.slice(0, 1)?.length > 0
        ? data?.label_list?.map(vv => vv?.label_name)?.slice(0, 1)
        : void 0,
    recommendation_trace_id: data?.recommend_trace_id || data?.recommendation_trace_id,
    is_hotdish: data?.is_hotdish,
    tag_key: data?.entrance_tag?.tag_key,
    tag_name: data?.entrance_tag?.tag_name,
    volume_price_support: data?.volume_price_support ? true : false,
    biz_type: data.biz_type || void 0,
    is_presale: data.is_presale,
    sale_event_id: data?.sale_event_id,
    extra_attrs: parsedExtraAttrs,
    url: data?.url,
    utm_campaign: data?.utm_campaign,
    coupon_type: data?.coupon_type,
    coupon_value: data?.coupon_value
  };
};

const formatItem = items => {
  if (!items?.length) return null;
  return items?.map(item => {
    return {
      product_id: item?.product_id,
      quantity: item?.quantity,
      source: item?.source,
      price: item?.price,
      base_price: item?.base_price ?? void 0,
      reason_type: item?.reason_type,
      status: item?.status,
      volume_price_support: item?.volume_price_support ? true : false,
      promotion_type: item.promotion_type ?? void 0,
      promotion_offer: item.promotion_offer ?? void 0,
      is_subscribe: (item?.user_subscribe && Object.keys(item?.user_subscribe)?.length > 0) || void 0
    };
  });
};

const formatItems = data => {
  let allProducts = [];
  let activityAll = [];
  let itemsAll = [];
  const activityInfo = data?.activity_info?.filter(vv => vv?.type !== 'trade_in') || [];
  for (let i = 0; i < activityInfo?.length; i++) {
    if (!!activityInfo[i]?.items?.length) {
      for (let m = 0; m < activityInfo[i]?.items?.length; m++) {
        let item = activityInfo[i]?.items[m];
        if (activityInfo[i]?.source === 'ec-promotion' && !!item) {
          item = {
            promotion_type: activityInfo[i]?.original_type,
            promotion_offer: activityInfo[i]?.is_offer,
            ...item
          };
        }
        activityAll = activityAll?.concat(item || []);
        if (!!activityInfo[i]?.items[m]?.activity_info?.length) {
          for (let n = 0; n < activityInfo[i]?.items[m]?.activity_info?.length; n++) {
            activityAll = activityAll?.concat(activityInfo[i]?.items[m]?.activity_info[n]?.items || []);
          }
        }
      }
    }
  }

  const itemsInfo = data?.items;
  for (let i = 0; i < itemsInfo?.length; i++) {
    itemsAll = itemsAll?.concat(itemsInfo[i] || []);
    if (!!itemsInfo[i]?.activity_info?.length) {
      for (let m = 0; m < itemsInfo[i]?.activity_info?.length; m++) {
        itemsAll = itemsAll?.concat(itemsInfo[i]?.activity_info[m]?.items || []);
      }
    }
  }
  allProducts = activityAll?.concat(itemsAll);
  return formatItem(allProducts);
};

const formatCart = data => {
  if (!data) return null;
  // 没有展示在页面上的数据，不传，that's why we need those showXXX
  return {
    type: data?.type,
    deal_id: data?.deal_id,
    quantity: data?.quantity,
    delivery_pickup_date: data?.shipping_info?.delivery_pickup_date,
    delivery_mode: data?.shipping_info?.delivery_mode,
    orignal_shipping_fee: data?.shipping_info?.orignal_shipping_fee,
    hotdish_wave: data?.shipping_info?.hotdish_wave,
    sub_total_price: data?.fee_info?.sub_total_price,
    total_price_with_activity: data?.fee_info?.total_price_with_activity,
    shipping_fee: data?.fee_info?.shipping_fee,
    vendor_id: data?.vendor_info?.vendor_id,
    items: formatItems(data),
    trade_in_items: formatItem(data?.activity_info?.find(vv => vv?.type === 'trade_in')?.items)
  };
};
const formatPopup = param => {
  if (!param) return null;
  return {
    ...param,
    action: param?.action,
    name: param?.name,
    id: param?.id,
    content_type: param?.content_type,
    url: param?.url,
    other_parameter: param?.other_parameter,
    target_url: param?.target_url
  };
};

export default function useImpressionT2() {
  const bannerImpression = param => {
    const params = formatParam(param);
    params.co = formatBanner(params?.co);
    if (params.page_key) {
      //兼容弹窗中的商品曝光page_key独立的问题
      new Tracker()
        .addEventInDialog(NewTracking.bannerImp, params, { page_key: params.page_key, view_id: params.view_id })
        .send();
    } else {
      new Tracker().addEventInQueue(NewTracking.bannerImp, params).send();
    }
  };

  const ellipseImpression = param => {
    const params = formatParam(param);
    params.co = formatEllipse(params?.co);
    new Tracker().addEventInQueue(NewTracking.ellipseImp, params).send();
  };

  const filterBtnImpression = param => {
    const params = formatParam(param);
    params.co = formatFilterBtn(params?.co);
    new Tracker().addEventInQueue(NewTracking.filterImp, params).send();
  };

  const productImpression = (param, isFromCart = false) => {
    if (param) {
      const params = formatParam(param);
      params.co = formatProductInfo(params?.co, isFromCart);
      if (params?.ctx) {
        params.ctx = formatCtx(params?.ctx);
      }
      if (params.page_key) {
        //兼容弹窗中的商品曝光page_key独立的问题
        new Tracker()
          .addEventInDialog(NewTracking.productImp, params, { page_key: params.page_key, view_id: params.view_id })
          .send();
      } else {
        new Tracker().addEventInQueue(NewTracking.productImp, params).send();
      }
    }
  };

  const cartImpression = (param, dialogParam?) => {
    const params = formatParam(param);
    params.co = formatCart(params?.co);
    if (dialogParam?.page_key) {
      //兼容弹窗中曝光page_key独立问题
      new Tracker()
        .addEventInDialog(NewTracking.cartImp, params, {
          page_key: dialogParam?.page_key,
          view_id: dialogParam?.view_id
        })
        .send();
    } else {
      new Tracker().addEventInQueue(NewTracking.cartImp, params).send();
    }
  };

  const pageSectionImpression = param => {
    const params = formatParam(param);
    new Tracker().addEventInQueue(NewTracking.pageSectionImp, params).send();
  };

  const popupImpression = (param, dialogParam?) => {
    const params = formatParam(param);
    params.co = formatPopup(params?.co);
    if (dialogParam?.page_key) {
      // 兼容弹窗中曝光修改page_key refer_page独立问题
      new Tracker().addEventInDialog(NewTracking.popup, params, dialogParam).send();
    } else {
      new Tracker().addEventInQueue(NewTracking.popup, params).send();
    }
  };

  const videoProductImpression = params => {
    new Tracker().addEventInQueue(NewTracking.productImp, params).send();
  };

  const useUpsellListImpression = params => {
    if (params) {
      params.url = window.location.pathname + window.location.search;
      params.page_url = window.location.href;
      params.referer = document.referrer;
      params.store = getCookie(constants.WEEE_STORE);
      params.source_store = getCookie(constants.WEEE_STORE);
      new Tracker().addEventInQueue(NewTracking.upsellListImpression, params).send();
    }
  };

  const videoImpression = param => {
    const params = formatParam(param);
    params.co = formatBanner(params?.co);
    new Tracker().addEventInQueue(NewTracking.bannerImp, params).send();
  };

  return {
    bannerImpression,
    ellipseImpression,
    filterBtnImpression,
    productImpression,
    cartImpression,
    pageSectionImpression,
    popupImpression,
    videoProductImpression,
    useUpsellListImpression,
    videoImpression
  };
}
